export enum TabsEnum{
    ADDRESS = "address",
    INVOICE_SETTINGS = "invoiceSettings",
    SETTINGS = "settings",
}